import GeneralSearch from "./generalSearch";

export { GeneralSearch };
